"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _filter2 = _interopRequireDefault(require("lodash/filter"));
var _map2 = _interopRequireDefault(require("lodash/map"));
var _Divider = _interopRequireDefault(require("material-ui/Divider"));
var _FlatButton = _interopRequireDefault(require("material-ui/FlatButton"));
var _InputText = _interopRequireDefault(require("../InputText"));
var _LabelInfo = _interopRequireDefault(require("../LabelInfo"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _Select = _interopRequireDefault(require("../Select"));
var _Toggle = _interopRequireDefault(require("../Toggle"));
require("./Form.scss");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);
  var _super = _createSuper(Form);
  function Form(props) {
    var _this;
    _classCallCheck(this, Form);
    _this = _super.call(this, props);
    _this.state = {
      isValid: true,
      elements: _objectSpread({}, props.elements)
    };
    _this.handleChangeWrapper = _this.handleChangeWrapper.bind(_assertThisInitialized(_this));
    _this.updateIsValid = _this.updateIsValid.bind(_assertThisInitialized(_this));
    _this.clearForm = _this.clearForm.bind(_assertThisInitialized(_this));
    return _this;
  }
  _createClass(Form, [{
    key: "generateLabel",
    value: function generateLabel(labelText, infoText, labelStyle) {
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "label-container",
        style: labelStyle
      }, /*#__PURE__*/_react["default"].createElement("span", null, labelText), infoText ? /*#__PURE__*/_react["default"].createElement(_LabelInfo["default"], {
        info: infoText
      }) : null);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      this.setState({
        elements: nextProps.elements
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var elements = this.state.elements;
      return /*#__PURE__*/_react["default"].createElement("form", {
        className: "cms-form ".concat(this.props.className),
        onSubmit: function onSubmit(event) {
          _this2.handleSubmitWrapper(event);
        }
      }, elements && (0, _map2["default"])(elements, function (element) {
        var infoText = typeof element.info !== 'undefined' && element.info.length > 0 ? element.info : null;
        switch (element.type) {
          case 'readonly':
            return null;
          case 'labelH1':
            return /*#__PURE__*/_react["default"].createElement("h1", {
              key: element.param
            }, element.label || element.value);
          case 'labelH2':
            return /*#__PURE__*/_react["default"].createElement("h2", {
              key: element.param
            }, element.label || element.value);
          case 'labelH3':
            return /*#__PURE__*/_react["default"].createElement("h3", {
              key: element.param
            }, element.label || element.value);
          case 'divider':
            return /*#__PURE__*/_react["default"].createElement(_Divider["default"], {
              key: element.param,
              style: {
                marginBottom: 30
              }
            });
          case 'select':
            return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
              value: element.value,
              key: element.param,
              style: element.style,
              name: element.param,
              underlineStyle: element.underlineStyle ? element.underlineStyle : _this2.props.underlineStyle,
              labelStyle: _this2.props.labelStyle,
              onChange: _this2.handleChangeWrapper,
              hintText: element.hintText,
              floatingLabel: element.floatingLabel,
              label: element.label,
              required: element.required,
              menuStyle: _this2.props.menuStyle,
              selectedMenuItemStyle: _this2.props.selectedMenuItemStyle,
              listStyle: _this2.props.listStyle,
              menuItemStyle: _this2.props.menuItemStyle,
              instructions: element.instructions,
              instructionsStyle: _this2.props.instructionsStyle,
              options: element.options
            });
          case 'select-multiple':
            return /*#__PURE__*/_react["default"].createElement(_Select["default"], {
              multiple: true,
              value: element.value,
              key: element.param,
              style: element.style,
              name: element.param,
              underlineStyle: element.underlineStyle ? element.underlineStyle : _this2.props.underlineStyle,
              labelStyle: _this2.props.labelStyle,
              onChange: _this2.handleChangeWrapper,
              hintText: element.hintText,
              floatingLabel: element.floatingLabel,
              label: element.label,
              required: element.required,
              menuStyle: _this2.props.menuStyle,
              selectedMenuItemStyle: _this2.props.selectedMenuItemStyle,
              listStyle: _this2.props.listStyle,
              menuItemStyle: _this2.props.menuItemStyle,
              instructions: element.instructions,
              instructionsStyle: _this2.props.instructionsStyle,
              options: element.options
            });
          case 'toggle':
            return /*#__PURE__*/_react["default"].createElement(_Toggle["default"], {
              valueFromInput: element.value,
              key: element.param,
              name: element.param,
              onChange: _this2.handleChangeWrapper,
              label: _this2.generateLabel(element.label, infoText)
            });
          case 'submit':
          case 'button':
            return /*#__PURE__*/_react["default"].createElement(_FlatButton["default"], {
              type: element.type,
              label: element.label,
              key: element.param,
              onClick: function onClick(event) {
                _this2.handleButtonClickWrapper(element.param);
              }
            });
          default:
          case 'text':
          case 'email':
          case 'password':
          case 'textarea':
            return /*#__PURE__*/_react["default"].createElement(_InputText["default"], {
              defaultValue: element.defaultValue,
              placeholder: element.placeholder,
              type: element.type,
              styleName: _this2.props.styleName,
              instructions: element.instructions,
              instructionsStyle: _this2.props.instructionsStyle,
              onChange: _this2.handleChangeWrapper,
              name: element.param,
              required: element.required,
              rows: element.rows,
              labelStyle: _this2.props.labelStyle,
              inputStyle: _this2.props.inputStyle,
              inputContainerStyle: _this2.props.inputContainerStyle,
              label: _this2.generateLabel(element.label, infoText),
              multiLine: element.type === 'textarea',
              key: element.param
            });
          case 'buttonBank':
            return /*#__PURE__*/_react["default"].createElement("div", {
              key: "button-bank",
              className: "button-bank",
              style: {
                display: "flex"
              }
            }, element.buttons.map(function (button, index) {
              return /*#__PURE__*/_react["default"].createElement(_FlatButton["default"], {
                label: button.label,
                className: button.param,
                key: button.param,
                onClick: function onClick(event) {
                  _this2["handleButtonBankButton" + (index + 1) + "ClickWrapper"](event);
                }
              });
            }));
        }
      }));
    }
  }, {
    key: "clearForm",
    value: function clearForm() {
      var _this3 = this;
      var elements = this.state.elements;
      elements && (0, _map2["default"])(elements, function (element) {
        element.value = element.type === 'select' ? null : '';
        if (_this3.props.handleChange !== undefined) {
          _this3.props.handleChange(element.param, element.value);
        }
      });
      this.setState({
        elements: elements
      });
      this.updateIsValid();
    }
  }, {
    key: "handleChangeWrapper",
    value: function handleChangeWrapper(attrb, value) {
      var elements = this.state.elements;
      elements[attrb].value = value;
      this.setState({
        elements: elements
      });
      this.updateIsValid();
      if (this.props.handleChange !== undefined) {
        this.props.handleChange(attrb, value);
      }
    }
  }, {
    key: "handleButtonClickWrapper",
    value: function handleButtonClickWrapper(paramName) {
      this.updateIsValid();
      if (this.props.handleButtonClick !== undefined) {
        this.props.handleButtonClick(paramName);
      }
    }
  }, {
    key: "handleSubmitWrapper",
    value: function handleSubmitWrapper(event) {
      if (this.props.handleSubmit !== undefined) {
        this.props.handleSubmit(event);
      }
    }
  }, {
    key: "handleButtonBankButton1ClickWrapper",
    value: function handleButtonBankButton1ClickWrapper(event) {
      if (this.props.handleButtonBankButton1Click !== undefined) {
        this.props.handleButtonBankButton1Click(event);
      }
    }
  }, {
    key: "handleButtonBankButton2ClickWrapper",
    value: function handleButtonBankButton2ClickWrapper(event) {
      if (this.props.handleButtonBankButton2Click !== undefined) {
        this.props.handleButtonBankButton2Click(event);
      }
    }
  }, {
    key: "updateIsValid",
    value: function updateIsValid() {
      var isValid = true;
      this.state.elements && (0, _map2["default"])(this.state.elements, function (element) {
        if (element.required && (element.value === null || element.value === '' || element.value === undefined)) {
          isValid = false;
        }
      });
      this.setState({
        isValid: isValid
      });
      if (typeof this.props.isValidCallback !== 'undefined') {
        this.props.isValidCallback(isValid);
      }
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateIsValid();
    }
  }]);
  return Form;
}(_react["default"].Component);
Form.defaultProps = {
  elements: {},
  handleChange: function handleChange(attrb, value) {
    //console.log('Value changed to ', value, ' for ', attrb);
  },
  styleName: "material",
  className: ""
};
Form.propTypes = {
  className: _propTypes["default"].string,
  elements: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].array]),
  labelStyle: _propTypes["default"].object,
  styleName: _propTypes["default"].string,
  inputStyle: _propTypes["default"].object,
  instructionsStyle: _propTypes["default"].object,
  underlineStyle: _propTypes["default"].object,
  menuStyle: _propTypes["default"].object,
  handleChange: _propTypes["default"].func,
  // Function that gets executed when any element changes its value
  handleSubmit: _propTypes["default"].func,
  isValidCallback: _propTypes["default"].func // Callback Function to execute to check if the form is Valid
};
var _default = Form;
exports["default"] = _default;